import * as React from "react";
const SvgAdd = props => <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" {...props}><path d="M38 26H26v12h-4V26H10v-4h12V10h4v12h12z" /><path fill="none" d="M0 0h48v48H0z" /></svg>;
export { SvgAdd as ReactComponent };